export function doLogin(username, password, remember) {
    return {
        type: 'AUTH_LOGIN',
        payload: {
            username, password, remember
        }
    }
}

export function getUserInfo(userToken) {
    return {
        type: 'AUTH_GET_INFO',
        payload: userToken,
    }
}

export function doLogout() {
    return {
        type: 'AUTH_LOGOUT'
    }
}